import { Logger, engineComponent } from "neo-common";
import { ComponentTypes } from "../../ComponentTypes";
import { ActionSet } from "../../ActionSet";
import { LinkedElementAttributes } from "../../ComponentAttributes";

/**
 * LinkedElement class is class which creates holder for other display objects.
 * Also handle all basic properties of display object as X, Y, Rotation, Tween, Scale, Visible, Mask (?)
 *
 * @class LinkedElement
 * @author Marek Turkovic
 */
@engineComponent(ComponentTypes.LinkedElement)
export class LinkedElement {
    constructor() {}

    /**
     *
     * @param node
     * @param nodeAttributes
     */
    public create(node: Element, nodeAttributes?: Element): void {
        if (node.hasAttribute(LinkedElementAttributes.LINKED_TO_ID)) {
            if (
                ActionSet.ElementsToLink != null &&
                ActionSet.ElementsToLink[node.getAttribute(LinkedElementAttributes.LINKED_TO_ID)] != null
            ) {
                let mainElement = ActionSet.ElementsToLink[node.getAttribute(LinkedElementAttributes.LINKED_TO_ID)];

                if (nodeAttributes != null) {
                    mainElement.updateByNode(nodeAttributes);
                } else {
                    mainElement.updateByNode(node);
                }
            }
        }
    }

    /**
     * @protected componentName - component type name.
     * @returns {string}
     */
    public get componentName(): string {
        return (this as any).__componentName__;
    }

    /**
     * Trace to browser console.
     * @method log
     * @param s string
     * @return void
     */
    protected log(s: string): void {
        if (DEBUG) {
            let compName = (this as any).__componentName__;
            Logger.debugGroup(compName, s);
        }
    }

    /**
     * Log error into console
     * @param s
     */
    protected logError(s: string): void {
        if (DEBUG) {
            let compName = (this as any).__componentName__;
            Logger.errorGroup(compName, s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Graphics/LinkedElement.ts
 **/